var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3 0H495.7V342H17.3V0Z",
    fill: "#181A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H513V114H0V0Z",
    fill: "#FFA44A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228H513V342H0V228Z",
    fill: "#1A9F0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114H513V228H0V114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 205.2C275.388 205.2 290.7 189.888 290.7 171C290.7 152.112 275.388 136.8 256.5 136.8C237.612 136.8 222.3 152.112 222.3 171C222.3 189.888 237.612 205.2 256.5 205.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 216.6C231.4 216.6 210.9 196.1 210.9 171C210.9 145.9 231.4 125.4 256.5 125.4C281.6 125.4 302.1 145.9 302.1 171C302.1 196.1 281.6 216.6 256.5 216.6ZM256.5 205.2C274.7 205.2 290.7 189.2 290.7 171C290.7 152.8 274.8 136.8 256.5 136.8C238.2 136.8 222.3 152.8 222.3 171C222.3 189.2 238.3 205.2 256.5 205.2Z",
    fill: "#181A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 193.8C269.092 193.8 279.3 183.592 279.3 171C279.3 158.408 269.092 148.2 256.5 148.2C243.908 148.2 233.7 158.408 233.7 171C233.7 183.592 243.908 193.8 256.5 193.8Z",
    fill: "#181A93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiFlag);
export default __webpack_public_path__ + "static/media/hi-flag.d6fd61f1e4c52756956833086383ec10.svg";
export { ForwardRef as ReactComponent };